import React, { useCallback, useState } from "react";
import { FormikHelpers } from "formik";
import axios from "axios";
import { routes } from "../../../vam/General";
import { User } from "../../../interface/user.interface";
import { InquiryParams, PolicyFormValues, PolicyOption } from "../../../vam/bi/schemas/policy.types";
import { Alert } from "../../../interface/alert.interface";

export const useCubePolicy = (user: User, alertRef?: React.RefObject<Alert | undefined>) => {
    const [policyOptions, setPolicyOptions] = useState<PolicyOption[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(
        (query: InquiryParams, actions?: FormikHelpers<PolicyFormValues>) => {
            const canFetch =
                user.isAdmin ||
                user.isBroker ||
                user.isEjecutivo ||
                (user.cdCliente && query.cdCliente === user.cdCliente);

            if (!canFetch) {
                actions?.setSubmitting(false);
                return;
            }

            setLoading(true);
            setPolicyOptions([]);

            axios
                .post(`${routes.api}/health-disaster/get-health-disasters`, query)
                .then(resp => {
                    const { status, message, cubeData } = resp.data;

                    if (status === "not_found" || !cubeData || cubeData.length === 0) {
                        alertRef?.current?.show_info(message || "No se encontraron pólizas para el cliente ingresado");
                        setPolicyOptions([]);
                        return;
                    }

                    if (status === "error") {
                        alertRef?.current?.show_error(message || "Error al obtener información del cliente");
                        setPolicyOptions([]);
                        return;
                    }

                    const policyOptions: PolicyOption[] = cubeData.map((item: PolicyOption) => ({
                        ...item,
                        policyValidations: item.policyValidations || [],
                    }));

                    setPolicyOptions(policyOptions);
                })
                .catch(error => {
                    console.error("Error al obtener datos de siniestralidad:", error);
                    alertRef?.current?.show_error("Error de conexión al obtener las pólizas");
                })
                .finally(() => {
                    setLoading(false);
                    actions?.setSubmitting(false);
                });
        },
        [user.isAdmin, user.isBroker, user.isEjecutivo, user.cdCliente]
    );

    return { policyOptions, loading, fetchData };
};
